import { z } from 'zod'
import { allocateCreditNoteSchema } from '@/features/invoices/models/schemas/credit-notes'
import { validateResponseIsOk } from '@/shared/api/validation'
import { createAssetManagementClient } from '@/shared/api/client'

const client = createAssetManagementClient()

export const allocateCreditNotesToInvoice = (invoiceId: number, allocations: z.infer<typeof allocateCreditNoteSchema>[]) => validateResponseIsOk(
  client.sendPut(`billing/invoices/${invoiceId}/credit-notes`, {
    data: z.array(allocateCreditNoteSchema).parse(allocations)
  }),
).then(
  () => { },
)
